import { GetAllCalendarForAllRoles } from "../api/Course";

/** Sayfa remount’larında aynı kurs listesini tekrar çekmemek için */
let cache = null;
let cacheAt = 0;
let inflight = null;

/** Stale veri riskini sınırlamak için kısa TTL */
const TTL_MS = 45_000;

function isCacheFresh() {
 return cache != null && Date.now() - cacheAt < TTL_MS;
}

/**
 * GetAllCalendarForAllRoles — tek istekte tüm liste (backend GetAll + Select).
 * @param {{ force?: boolean }} [options] force=true ise cache temizlenip yeniden çekilir
 */
export function getCourseCalendarListCached({ force = false } = {}) {
 if (force) {
  clearCourseCalendarCache();
 }
 if (isCacheFresh()) return Promise.resolve(cache);
 if (inflight) return inflight;

 inflight = GetAllCalendarForAllRoles()
  .then((response) => {
   const items = response?.data?.items ?? [];
   cache = items;
   cacheAt = Date.now();
   return items;
  })
  .finally(() => {
   inflight = null;
  });

 return inflight;
}

export function clearCourseCalendarCache() {
 cache = null;
 cacheAt = 0;
 inflight = null;
}

/** Kayıt ekleme/silme sonrası güncel liste için */
export function refreshCourseCalendarList() {
 return getCourseCalendarListCached({ force: true });
}

/**
 * Axios mutasyon URL’lerinden calendar cache’i invalidate et.
 * (GetAllCalendarForAllRoles POST olduğu için tüm Courses POST’ları değil.)
 */
export function shouldClearCourseCalendarCache(config) {
 const method = (config?.method || "get").toLowerCase();
 if (!["post", "put", "delete", "patch"].includes(method)) return false;

 const url = String(config?.url || "").toLowerCase();
 if (/courseregisters\/(add|delete)/i.test(url)) return true;
 if (/courseadministrators\/(add|delete)/i.test(url)) return true;
 if (/courses\/(add|update|updatestatus)\b/i.test(url)) return true;
 return false;
}
